export default {
    logout_prompt_title: "Cerrar sesión",
    logout_prompt_message: "Es necesario volver a iniciar sesión para aplicar los cambios"
};